// Video Shopping Vanilla JavaScript (rev)
// Inicialização robusta para Safari (Swiper tradicional) e outros (Swiper Web Component)

(function () {
  'use strict';

  // Evita carregar duas vezes
  if (window.VideoShoppingVanillaLoaded) return;
  window.VideoShoppingVanillaLoaded = true;

  // --- Utils
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua); // Chrome iOS também é WebKit, então tratamos via isIOS
  const useSafariSwiper = isSafari || isIOS;
  
  // Debug logging
  console.log('[VideoShopping] Browser detection:', { isIOS, isSafari, useSafariSwiper, userAgent: ua });

  // Seletores fixos da section
  const SAFARI_CONTAINER_SEL = '.safari-swiper-container';
  const SAFARI_SWIPER_SEL = '.safari-swiper';
  const WC_CONTAINER_SEL = '.web-component-swiper-container';
  const WC_SWIPER_SEL = '.video-shopping-swiper';

  class VideoShopping {
    constructor() {
      this.swiper = null;
      this.videos = [];
      this.currentSlide = 0;
      this.prevButton = null;
      this.nextButton = null;
      this.mode = useSafariSwiper ? 'safari' : 'wc';
      this._inited = false;
      this._boundDocClickPlay = null;

      this.init();
    }

    async init() {
      try {
        console.log('[VideoShopping] Starting initialization with mode:', this.mode);
        this.toggleContainers(this.mode);

        if (this.mode === 'safari') {
          await this.ensureSwiperTraditional();
          this.initSwiperTraditional();
        } else {
          await this.ensureSwiperElement();
          this.initSwiperElement();
        }

        // Aguarda um pouco para garantir que o Swiper esteja totalmente inicializado
        await new Promise(resolve => setTimeout(resolve, 100));

        // Inicializa vídeos e eventos após Swiper existir
        this.initializeVideos();
        this.bindEvents();

        // Pausar em perda de foco
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pause();
        });

        this._inited = true;
        console.log('[VideoShopping] Initialization completed successfully');
      } catch (err) {
        console.warn('[VideoShopping] Falha na inicialização, aplicando fallback Web Component.', err);
        // Fallback: tenta WC
        try {
          this.mode = 'wc';
          this.toggleContainers('wc');
          await this.ensureSwiperElement();
          this.initSwiperElement();
          
          // Aguarda um pouco para garantir que o Swiper esteja totalmente inicializado
          await new Promise(resolve => setTimeout(resolve, 100));
          
          this.initializeVideos();
          this.bindEvents();
          this._inited = true;
          console.log('[VideoShopping] Fallback initialization completed successfully');
        } catch (err2) {
          console.error('[VideoShopping] Fallback também falhou.', err2);
        }
      }
    }

    // Exibe/esconde containers (substitui o script inline do Liquid)
    toggleContainers(mode) {
      const safariCtn = document.querySelector(SAFARI_CONTAINER_SEL);
      const wcCtn = document.querySelector(WC_CONTAINER_SEL);

      console.log('[VideoShopping] Toggling containers:', { mode, safariCtn: !!safariCtn, wcCtn: !!wcCtn });

      if (safariCtn) {
        safariCtn.style.display = mode === 'safari' ? 'block' : 'none';
        console.log('[VideoShopping] Safari container display:', safariCtn.style.display);
      }
      if (wcCtn) {
        wcCtn.style.display = mode === 'wc' ? 'block' : 'none';
        console.log('[VideoShopping] Web Component container display:', wcCtn.style.display);
      }
    }

    // --- Carregamento de libs
    ensureSwiperTraditional() {
      return new Promise((resolve) => {
        // CSS
        if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
          document.head.appendChild(link);
        }
        // JS
        if (typeof window.Swiper !== 'undefined') return resolve();
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.onload = () => resolve();
        document.head.appendChild(script);
      });
    }

    ensureSwiperElement() {
      return new Promise((resolve) => {
        // CSS
        if (!document.querySelector('link[href*="swiper-element-bundle.min.css"]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.min.css';
          document.head.appendChild(link);
        }
        // JS + definição do custom element
        const afterDefined = () => {
          // Aguarda a definição do custom element antes de prosseguir
          if (window.customElements && customElements.whenDefined) {
            customElements.whenDefined('swiper-container').then(() => resolve());
          } else {
            // Ambiente sem customElements? resolve assim mesmo.
            resolve();
          }
        };

        if (window.customElements && customElements.get && customElements.get('swiper-container')) {
          return resolve();
        }
        if (document.querySelector('script[src*="swiper-element-bundle.min.js"]')) {
          return afterDefined();
        }
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.min.js';
        script.onload = afterDefined;
        document.head.appendChild(script);
      });
    }

    // --- Instâncias Swiper
    initSwiperTraditional() {
      const el = document.querySelector(SAFARI_SWIPER_SEL);
      if (!el) {
        console.warn('[VideoShopping] .safari-swiper não encontrado.');
        return;
      }
      const initialSlide = parseInt(el.getAttribute('data-initial-slide')) || 0;

      // Instância única
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      this.swiper = new window.Swiper(SAFARI_SWIPER_SEL, {
        effect: 'slide',
        slidesPerView: 'auto',
        centeredSlides: true,
        grabCursor: true,
        initialSlide,
        watchSlidesProgress: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.target-video-slider-section__container__buttons__next__button',
          prevEl: '.target-video-slider-section__container__buttons__prev__button'
        },
        on: {
          slideChange: (sw) => {
            this.currentSlide = sw.activeIndex;
            this.handleSlideChange(sw.activeIndex);
          }
        }
      });

      this.initializeButtons();
    }

    initSwiperElement() {
      const el = document.querySelector(WC_SWIPER_SEL);
      if (!el) {
        console.warn('[VideoShopping] .video-shopping-swiper não encontrado.');
        return;
      }

      const attach = () => {
        // Já inicializado?
        if (el.swiper) {
          this.swiper = el.swiper;
          this.swiper.on('slideChange', (sw) => {
            this.currentSlide = sw.activeIndex;
            this.handleSlideChange(sw.activeIndex);
          });
          this.initializeButtons();
        } else {
          // Fallback: espera um pouco e tenta de novo
          setTimeout(() => {
            if (el.swiper) {
              this.swiper = el.swiper;
              this.swiper.on('slideChange', (sw) => {
                this.currentSlide = sw.activeIndex;
                this.handleSlideChange(sw.activeIndex);
              });
              this.initializeButtons();
            }
          }, 300);
        }
      };

      // Alguns builds disparam 'ready', outros 'swiperinit'
      el.addEventListener('ready', attach, { once: true });
      el.addEventListener('swiperinit', attach, { once: true });

      // Se por acaso já estiver pronto
      if (el.swiper) attach();
    }

    initializeButtons() {
      this.prevButton = document.querySelector('.target-video-slider-section__container__buttons__prev__button');
      this.nextButton = document.querySelector('.target-video-slider-section__container__buttons__next__button');

      if (this.prevButton) {
        this.prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.swiper && this.swiper.slidePrev();
        }, { passive: false });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.swiper && this.swiper.slideNext();
        }, { passive: false });
      }
    }

    // --- Vídeos
    initializeVideos() {
      const containers = document.querySelectorAll('.video-shopping-section__container__content__video');
      this.videos = [];

      console.log('[VideoShopping] Initializing videos, found containers:', containers.length);

      containers.forEach((container, idx) => {
        const video = container.querySelector('video');
        const playButton = container.querySelector('.play-button');

        console.log('[VideoShopping] Processing container', idx, { hasVideo: !!video, hasPlayButton: !!playButton });

        if (!video) {
          // Se não há <video> (ex.: asset sem mp4), verifica se há placeholder
          const placeholder = container.querySelector('.video-placeholder');
          if (placeholder) {
            console.log('[VideoShopping] Found placeholder for slide:', idx);
            // Mantém o slide visível com placeholder
            this.videos[idx] = { container, video: null, playButton, placeholder: true };
            return;
          } else {
            // Se não há nem vídeo nem placeholder, esconde o slide
            const slide = container.closest('.swiper-slide, swiper-slide');
            if (slide) {
              slide.style.display = 'none';
              console.log('[VideoShopping] Hiding slide without video or placeholder:', idx);
            }
            return;
          }
        }

        // Setup inicial seguro
        video.controls = false;
        video.muted = true;
        video.loop = false;
        video.preload = 'metadata';
        video.playsInline = true;

        // Garantir que poster apareça mesmo se metadata atrasar
        video.addEventListener('loadstart', () => this.updatePlayButton(container, true));
        video.addEventListener('loadedmetadata', () => this.updatePlayButton(container, true));

        // Controle de play/pause/ended
        video.addEventListener('play', () => {
          this.updatePlayButton(container, false);
          this.createVolumeControls(container);
          this.pauseAllOtherVideos(idx);
          // habilita interação com controles
          video.controls = true;
          video.muted = false;
          video.loop = true;
          video.style.pointerEvents = 'auto';
          video.classList.add('controls-active');
        });

        video.addEventListener('pause', () => {
          this.updatePlayButton(container, true);
          this.removeVolumeControls(container);
          this.resetVideoControls(video);
        });

        video.addEventListener('ended', () => {
          this.updatePlayButton(container, true);
          this.removeVolumeControls(container);
          this.resetVideoControls(video);
        });

        this.videos[idx] = { container, video, playButton };
      });
    }

    bindEvents() {
      // Evita duplicar se re-inicializar
      if (this._boundDocClickPlay) {
        document.removeEventListener('click', this._boundDocClickPlay, true);
      }

      // Delegação para play-button
      this._boundDocClickPlay = (e) => {
        const btn = e.target.closest('.play-button');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          const container = btn.closest('.video-shopping-section__container__content__video');
          this.togglePlay(container);
          return;
        }

        const container = e.target.closest('.video-shopping-section__container__content__video');
        if (container) {
          // Ignora cliques nos controles customizados e em links do product card
          if (e.target.closest('.custom-volume-controls') || e.target.closest('.product-card-link')) return;
          e.preventDefault();
          e.stopPropagation();
          this.togglePlay(container);
        }
      };

      document.addEventListener('click', this._boundDocClickPlay, true);

      window.addEventListener('resize', () => {
        // Nada específico por enquanto; mantemos para futura responsividade
      });
    }

    togglePlay(container) {
      const video = container ? container.querySelector('video') : null;
      if (!video) {
        console.log('[VideoShopping] No video found in container, skipping play');
        return;
      }
      if (video.paused) this.playVideo(video);
      else this.pauseVideo(video);
    }

    playVideo(video) {
      // Config antes do .play()
      video.controls = true;
      video.muted = false;
      video.loop = true;
      video.style.pointerEvents = 'auto';
      video.classList.add('controls-active');

      video.play().catch(() => {
        // Se o browser exigir gesto do usuário, ao menos deixe os controles visíveis
        video.controls = true;
        video.muted = false;
        video.style.pointerEvents = 'auto';
        video.classList.add('controls-active');
      });
    }

    pauseVideo(video) {
      video.pause();
      video.muted = true;
      video.controls = false;
      video.loop = false;
      this.resetVideoControls(video);
    }

    resetVideoControls(video) {
      video.controls = false;
      video.muted = true;
      video.loop = false;
      video.style.pointerEvents = 'none';
      video.classList.remove('controls-active');
      // força reflow
      // eslint-disable-next-line no-unused-expressions
      video.offsetHeight;
    }

    updatePlayButton(container, show) {
      const btn = container.querySelector('.play-button');
      if (!btn) return;
      btn.classList.toggle('hidden', !show);
    }

    pauseAllOtherVideos(currentIdx) {
      this.videos.forEach((v, idx) => {
        if (!v || !v.video) return;
        if (idx === currentIdx) return;
        this.pauseVideo(v.video);
        this.updatePlayButton(v.container, true);
        this.removeVolumeControls(v.container);
      });
    }

    handleSlideChange() {
      // Pausa todos os vídeos ao trocar de slide
      this.videos.forEach((v) => {
        if (!v || !v.video) return;
        this.pauseVideo(v.video);
        this.updatePlayButton(v.container, true);
        this.removeVolumeControls(v.container);
      });
    }

    // --- Controles de volume custom
    createVolumeControls(container) {
      this.removeVolumeControls(container);

      const volumeControls = document.createElement('div');
      volumeControls.className = 'custom-volume-controls';
      volumeControls.innerHTML = `
        <div class="volume-controls-wrapper">
          <button class="volume-mute-btn" aria-label="Mute/Unmute">
            <svg class="volume-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.54 8.46C16.48 9.4 17 10.75 17 12.18C17 13.61 16.48 14.96 15.54 15.9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19.07 4.93C20.94 6.81 22 9.35 22 12.18C22 15.01 20.94 17.55 19.07 19.43" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="volume-slider-container">
            <input type="range" class="volume-slider" min="0" max="100" value="100" aria-label="Volume">
          </div>
        </div>
      `;
      container.appendChild(volumeControls);

      const video = container.querySelector('video');
      const muteBtn = volumeControls.querySelector('.volume-mute-btn');
      const slider = volumeControls.querySelector('.volume-slider');
      const icon = volumeControls.querySelector('.volume-icon');

      // Estado inicial
      video.volume = 1;
      video.muted = false;

      const updateIcon = () => {
        const vol = video.muted ? 0 : video.volume;
        if (vol === 0) {
          icon.innerHTML = `
            <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          `;
        } else if (vol < 0.5) {
          icon.innerHTML = `
            <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.54 8.46C16.48 9.4 17 10.75 17 12.18C17 13.61 16.48 14.96 15.54 15.9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          `;
        } else {
          icon.innerHTML = `
            <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.54 8.46C16.48 9.4 17 10.75 17 12.18C17 13.61 16.48 14.96 15.54 15.9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.07 4.93C20.94 6.81 22 9.35 22 12.18C22 15.01 20.94 17.55 19.07 19.43" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          `;
        }
      };

      slider.addEventListener('input', (e) => {
        const v = Number(e.target.value) / 100;
        video.volume = v;
        video.muted = v === 0;
        updateIcon();
      });

      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        slider.value = video.muted ? '0' : String(Math.round(video.volume * 100));
        updateIcon();
      });

      updateIcon();
    }

    removeVolumeControls(container) {
      const existing = container.querySelector('.custom-volume-controls');
      if (existing) existing.remove();
    }

    // API pública opcional
    play() {
      const v = this.videos[this.currentSlide];
      if (v && v.video) this.playVideo(v.video);
    }
    pause() {
      const v = this.videos[this.currentSlide];
      if (v && v.video) this.pauseVideo(v.video);
    }
    next() {
      this.swiper && this.swiper.slideNext();
    }
    prev() {
      this.swiper && this.swiper.slidePrev();
    }
  }

  // Bootstrap
  function start() {
    // Aguarda DOM completo (e dá um micro delay para markup de blocks estar no DOM)
    const kick = () => {
      // Verifica se já existe uma instância
      if (window.VideoShoppingInstance) {
        console.log('[VideoShopping] Instance already exists, skipping initialization');
        return;
      }
      
      // Aguarda um pouco mais para garantir que todos os recursos estejam carregados
      setTimeout(() => {
        try {
          window.VideoShoppingInstance = new VideoShopping();
          console.log('[VideoShopping] New instance created successfully');
        } catch (error) {
          console.error('[VideoShopping] Failed to create instance:', error);
        }
      }, 200);
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', kick, { once: true });
    } else {
      kick();
    }
  }

  start();
  window.VideoShopping = VideoShopping;
})();
